import { render, staticRenderFns } from "./MenuContentPurchase.vue?vue&type=template&id=6d08a1e1&scoped=true"
var script = {}
import style0 from "./MenuContentPurchase.vue?vue&type=style&index=0&id=6d08a1e1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d08a1e1",
  null
  
)

export default component.exports